import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { postAuthLogin, postAuthRegister, getAuthLogout } from '../api/auth-api/auth-api';
import { useAuth as useAuthContext } from '../lib/AuthContext';
import { UserDto } from '../api/model';
import { queryClient } from '../lib/query-client';

// auth hooks
export const useLogin = () => {
  const { login } = useAuthContext();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (credentials: { username: string; password: string }) => {
      const response = await postAuthLogin(credentials);
      return response;
    },
    onSuccess: (data: any) => {
      const token = data.token || data.jwt || data.accessToken;
      
      if (token) {
        login(token);
      } else {
        throw new Error('Authentication failed');
      }
    },
  });
};

export const useRegister = () => {
  return useMutation({
    mutationFn: async (data: UserDto) => {
      const response = await postAuthRegister(data);
      return response;
    },
  });
};


export const useLogout = () => {
  const { logout } = useAuthContext();
  const navigate = useNavigate();

  return async () => {
    try {
      await getAuthLogout();
    } catch (error) {
      console.error('Logout API error:', error);
    } finally {
      queryClient.clear();
      logout();
      navigate({ to: '/' });
    }
  };
};
